import React from 'react';
import { Facebook, Linkedin, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';

const openCookiePreferences = (e) => {
  e?.preventDefault();
  window.dispatchEvent(new CustomEvent('open-cookie-preferences'));
};

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Logo */}
          <div className="lg:col-span-1">
            <img
              src="https://customer-assets.emergentagent.com/job_dc63fc88-a4c1-4ec0-a429-62db7388c03c/artifacts/qlcn8omg_ECOMM%20LOGO.PNG"
              alt="eCOMM Merchant Solutions"
              className="h-10 w-auto brightness-0 invert"
            />
          </div>

          {/* Products */}
          <div>
            <h3 className="text-sm font-semibold mb-4 tracking-wider">Products</h3>
            <ul className="space-y-2">
              <li><Link to="/products/ecommerce-solutions" state={{ from: 'footer' }} className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-ecommerce">eCommerce</Link></li>
              <li><Link to="/products/pos-card-machines" state={{ from: 'footer' }} className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-pos-machines">POS Machines</Link></li>
              <li><Link to="/products/epos-and-mini" state={{ from: 'footer' }} className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-epos">EPOS Solutions</Link></li>
              <li><Link to="/products/ecommerce-solutions#advanced-features" state={{ from: 'footer' }} className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-pay-by-link">Pay By Link</Link></li>
              <li><Link to="/products/ecommerce-solutions#advanced-features" state={{ from: 'footer' }} className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-recurring-billing">Recurring Billing</Link></li>
              <li><Link to="/products/softpos-and-mpos" state={{ from: 'footer' }} className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-smart-payments">Smart Payments</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold mb-4 tracking-wider">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about/company" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-about-us">About Us</Link></li>
              <li><Link to="/about/press-and-media" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-media-awards">Media & Awards</Link></li>
              <li><Link to="/about/social-responsibility" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-responsible-business">Responsible Business</Link></li>
              <li><Link to="/about/partner-with-us" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-affiliates">Affiliates</Link></li>
              <li><Link to="/sca-statement" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-sca-statement">SCA Statement</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold mb-4 tracking-wider">Resources</h3>
            <ul className="space-y-2">
              <li><Link to="/business-forms" state={{ from: 'footer' }} className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-document-library">Document Library</Link></li>
              <li><Link to="/accepting-payments-faqs" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-payment-faqs">Payments FAQs</Link></li>
              <li><Link to="/help-centre" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-help-articles">Help Articles</Link></li>
              <li><Link to="/about/ethical-business" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-modern-slavery">Modern Slavery Statement</Link></li>
              <li><Link to="/complaints-resolution" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-complaints-resolution">Complaints &amp; Resolution</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold mb-4 tracking-wider">Contact</h3>
            <div className="space-y-3">
              <div>
                <p className="text-gray-400 text-sm">Customer Support</p>
                <p className="text-gray-300 text-sm">+353 (0) 46 901 1288 (IR)</p>
                <p className="text-gray-300 text-sm">+44 (0) 20 7183 5253 (UK)</p>
              </div>
              <div>
                <p className="text-gray-400 text-sm">Customer Service</p>
                <p className="text-gray-300 text-sm">csr@ecomm365.com</p>
              </div>
            </div>
          </div>
        </div>

        {/* Disclaimer Section */}
        <div className="mt-10 pt-8 border-t border-gray-800">
          <div className="flex flex-col lg:flex-row justify-between items-start gap-6">
            <p className="text-gray-500 text-xs leading-relaxed lg:max-w-4xl">
              eCOMM Merchant Solutions Limited is authorised by the Financial Conduct Authority in the United Kingdom under licence number 900591. eCOMM Merchant Solutions Ireland Limited (EMSIL) registered in Ireland (Company No. 540660), a payment service provider and Paynetics AD ("Paynetics") acquirer of EMSIL regulated by the Bulgarian National Bank No. 44/11.04.2016 to provide e-Money services across the EU Member States on the grounds of its license passportisation. eCOMM's registered Ireland address 2 Bedford Place, Navan, Co. Meath, C15 VRF3 and UK registered address 86-90 Paul Street, EC2A 4NF, London. eCOMM complies with leading international security standards, including PCI DSS, SOC 1 and SOC 2, in addition to applicable local regulations. The provision of payment terminals is not regulated by the FCA.
            </p>
            {/* Social Icons */}
            <div className="flex space-x-3 flex-shrink-0">
              <a
                href="#"
                className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors"
                aria-label="Facebook"
                data-testid="footer-social-facebook"
              >
                <Facebook className="h-4 w-4 text-gray-400" />
              </a>
              <a
                href="#"
                className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors"
                aria-label="X (Twitter)"
                data-testid="footer-social-twitter"
              >
                <svg className="h-4 w-4 text-gray-400" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a
                href="#"
                className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors"
                aria-label="LinkedIn"
                data-testid="footer-social-linkedin"
              >
                <Linkedin className="h-4 w-4 text-gray-400" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-gray-800">
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-5">
            {/* Left — language selector */}
            <div className="flex items-center space-x-2 text-gray-400 text-sm">
              <Globe className="h-4 w-4" />
              <span>United Kingdom (English)</span>
            </div>

            {/* Right cluster — copyright + (PCI badge + legal links) + regulation note */}
            <div className="flex flex-col items-start lg:items-end gap-1.5">
              <p className="text-gray-400 text-sm">
                © 2026 eCOMM Merchant Solutions. All rights reserved.
              </p>
              <div className="flex items-center gap-x-2 sm:gap-x-3 gap-y-1 flex-wrap text-xs sm:text-sm">
                <div className="w-full sm:w-auto flex items-center gap-2 sm:gap-3">
                  <img
                    src="https://customer-assets.emergentagent.com/job_6323abd7-24b9-4750-94c8-d1bc2ce3dd11/artifacts/sv4k3rhu_IM6.png"
                    alt="PCI DSS Compliant"
                    className="h-10 sm:h-12 w-auto"
                    data-testid="footer-pci-logo"
                  />
                  <span className="hidden sm:inline text-gray-600">|</span>
                </div>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-link-privacy-policy">Privacy Policy</Link>
                <span className="text-gray-600">|</span>
                <Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-link-terms-of-service">Terms of Service</Link>
                <span className="text-gray-600">|</span>
                <Link to="/cookies-policy" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-link-cookies-policy">Cookie Policy</Link>
                <span className="text-gray-600">|</span>
                <button
                  type="button"
                  onClick={openCookiePreferences}
                  className="text-gray-400 hover:text-white transition-colors"
                  data-testid="footer-link-manage-cookies"
                >
                  Manage Cookies
                </button>
              </div>
              <p className="text-gray-500 text-xs">
                Regulated by the FCA in the UK | Certified Processor with Visa, Mastercard and AMEX
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
